export const selectedFolderNodeScreenReaderOnlyText = "_3b";
export default {selectedFolderNodeScreenReaderOnlyText};